import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { retries: { type: Number, default: 20 } }

  connect() {
    this.#fillCurrentPage()
  }

  disconnect() {
    clearTimeout(this.retryTimer)
  }

  // Formstack injects its form asynchronously, so poll until the field
  // exists or the retries run out.
  #fillCurrentPage(attempt = 0) {
    const input = this.element.querySelector(
      '[fs-field-validation-name="Current Page"] input'
    )

    if (input) {
      input.value = window.location.href
    } else if (attempt < this.retriesValue) {
      this.retryTimer = setTimeout(
        () => this.#fillCurrentPage(attempt + 1), 250
      )
    }
  }
}
